import service from "../libs/request.js";

// 获取预决算专栏列表
var getpreComputation = function(postdata, callback) {
  service.get({
    url: "/wzPreComputation/getList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
var getwzPreComputationInfo = function(postdata, callback) {
  service.get({
    url: "/wzPreComputation/getInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

var getDocList = function(postdata, callback) {
  service.get({
    url: "/resetful/docList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

var getwzMedicalAffairsInfo = function(postdata, callback) {
  service.get({
    url: "/wzMedicalAffairs/getInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

var getwzHospitalNoticeList = function(postdata, callback) {
  service.get({
    url: "/wzHospitalNotice/getList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 媒体看盛京  内容
var getwzMediaViewsjInfo = function(postdata, callback) {
  service.get({
    url: "/wzMediaViewsj/getInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

var getwzSjWatchInfo = function(postdata, callback) {
  service.get({
    url: "/wzSjWatch/getInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
var getwzHospitalNoticeInfo = function(postdata, callback) {
  service.get({
    url: "/wzHospitalNotice/getInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
var getwzBiddingNoticeList = function(postdata, callback) {
  service.get({
    url: "/wzBiddingNotice/getList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
var getwzBiddingNoticeInfo = function(postdata, callback) {
  service.get({
    url: "/wzBiddingNotice/getInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
var getwzDrugTestOrgList = function(postdata, callback) {
  service.get({
    url: "/wzDrugTestOrg/getList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

var getwzBiddingNotice = function(postdata, callback) {
  service.post({
    url: "/wzBiddingNotice/create",
    data: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
var getwzTvList = function(postdata, callback) {
  service.get({
    url: "/wzSjTv/getList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取盛京医讯
var getwzSjMedicalInformationList = function(postdata, callback) {
  service.get({
    url: "/wzSjMedicalInformation/getList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取盛京医讯列表
var getwzSjMedicalInformationMenuList = function(postdata, callback) {
  service.get({
    url: "/wzSjMedicalInformation/getMenuList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

//获取盛京医讯列表
var getwzSjMedicalInformationInfo = function(postdata, callback) {
  service.get({
    url: "/wzSjMedicalInformation/getMenuInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
//获取导航菜单数据列表;
var getwzNavigationList = function(postdata, callback) {
  service.get({
    url: "/wzNavigation/getDataList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 获取导航菜单数据
var getwzNavigationMenuInfo = function(postdata, callback) {
  service.get({
    url: "/wzNavigation/getMenuInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 获取动态导航列表
var getNavList = function(postdata, callback) {
  service.get({
    url: "/wzNavigation/getNavList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 获取动态导航菜单列表
var getNavMenuList = function(postdata, callback) {
  service.get({
    url: "/wzNavigation/getNavMenuList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 废弃
var getContent = function(postdata, callback) {
  service.get({
    url: "/resetful/getDepartment",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 公用

// 获取盛京看点列表
var getWatchList = function(postdata, callback) {
  service.get({
    url: "/wzSjWatch/getList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取媒体看盛京列表
var getwzMediaViewsjList = function(postdata, callback) {
  service.get({
    url: "/wzMediaViewsj/getList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取医疗纵横列表;
var getwzMedicalAffairsList = function(postdata, callback) {
  service.get({
    url: "/wzMedicalAffairs/getList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 访客
var getVisitor = function(postdata, callback) {
  service.get({
    url: "/wzIndexSelect/getVisitor",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 首页banner list
var getBannerList = function(postdata, callback) {
  service.get({
    url: "/wzPicture/getIndexList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 其它栏目 banner 列表
var getOtherList = function(postdata, callback) {
  service.get({
    url: "/wzPicture/getOtherList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 获取全部置灰
var setAllGray = function(postdata, callback) {
  service.get({
    url: "/wzOneKeyGraying/selectGall",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取首页置灰
var setIndexGray = function(postdata, callback) {
  service.get({
    url: "/wzOneKeyGraying/selectGindex",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取手机预约
var getOnlineInfo = function(postdata, callback) {
  service.get({
    url: "/wzQtuse/getOnlineInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取手机APP
var getAppInfo = function(postdata, callback) {
  service.get({
    url: "/wzQtuse/getAppInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取官方微信
var getWxInfo = function(postdata, callback) {
  service.get({
    url: "/wzQtuse/getWxInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 获取国家临床重点专科列表
var getKeyList = function(postdata, callback) {
  service.get({
    url: "/wzMedicalCare/getKeyList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 获取特色医疗中心列表
var getCenterList = function(postdata, callback) {
  service.get({
    url: "/wzMedicalCare/getCenterList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取盛京TV列表
var getwzTvList = function(postdata, callback) {
  service.get({
    url: "/wzSjTv/getList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取盛京医院的故事列表
var getSyHisList = function(postdata, callback) {
  service.get({
    url: "/wzSjCulture/getSyHisList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
var getChannelInfoList = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getInfoList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取健康教育-栏目列表
var getChannelList = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getChannelList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取主题教育列表
var getSubjectList = function(postdata, callback) {
  service.get({
    url: "/wzZtEducation/getList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 获取主题教育列表
var getSubjectArticle = function(postdata, callback) {
  service.get({
    url: "/wzZtEducation/getInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

export default {
  getDocList,
  getpreComputation,
  getwzPreComputationInfo,
  getwzMedicalAffairsInfo,
  getwzHospitalNoticeList,
  getwzMediaViewsjInfo,
  getwzSjWatchInfo,
  getwzHospitalNoticeInfo,
  getwzBiddingNoticeList,
  getwzBiddingNoticeInfo,
  getwzDrugTestOrgList,
  getwzBiddingNotice,
  getwzTvList,
  getwzSjMedicalInformationList,
  getwzSjMedicalInformationMenuList,
  getwzSjMedicalInformationInfo,
  getwzNavigationList,
  getwzNavigationMenuInfo,
  getNavMenuList,
  getNavList,
  getVisitor,
  getBannerList,
  getOtherList,
  setAllGray,
  setIndexGray,
  getOnlineInfo,
  getAppInfo,
  getWxInfo,
  getCenterList,
  getwzTvList,
  getSyHisList,
  getSubjectList,
  getSubjectArticle,
  // 废弃
  getContent,
  // 公用
  getWatchList,
  getwzMediaViewsjList,
  getwzMedicalAffairsList,
  getKeyList,
  getChannelInfoList,
  getChannelList,
};
